const makeUrlResolver = (endpoint) => (id) =>
  `api/${endpoint}${id ? `/${id}` : ''}`;

const endpoints = {
  auth: 'api/auth/local',
  upload: 'api/upload',

  objects: makeUrlResolver('objects'),
  objectsSuggested: makeUrlResolver('object-suggesteds'),
  categories: makeUrlResolver('categories'),
};

export default endpoints;
